<div class="modal-content">
  <div class="modal-header">
    <span>{{ isUpdate ? "Edit" : "Add" }} Resource</span>
    <i class="material-icons" data-bs-dismiss="modal" (click)="closeModal()"
      >close</i
      >
    </div>
    <div class="modal-body" style="overflow-y: unset">
      <form [formGroup]="uploadResourceForm">
        @if (errMessage && dataSubmitted && resourceData?.type !== 1) {
          <p
            class="text-danger"
            >
            {{ errMessage }}
          </p>
        }
        <div class="form-group row align-items-center">
          <label for="Title" class="col-sm-3 control-label">Title</label>
          <div
            class="col-sm-9 error-container"
            [ngClass]="{ error: dataSubmitted && form.title.errors }"
            >
            <input
              type="text"
              id="Title"
              formControlName="title"
              name="Title"
              style="text-transform: none"
              class="form-control vplaybook__form__inputs"
              placeholder="Max. 100 characters"
              />
            @if (dataSubmitted && form.title.errors) {
              <div class="text-danger">
                @if (form.title.errors.required) {
                  <div>Please enter the title</div>
                }
                @if (form.title.errors.maxlength) {
                  <div>
                    Your title Should not be more than 100 Characters
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="form-group row align-items-center">
          <label for="" class="col-sm-3 control-label">Type</label>
          <div class="col-sm-9 btn-group" role="group">
            <button
              id="resourceFileTypeButtonId"
              type="button"
            [class]="
              !resourceData?.type || resourceData?.type == 0
                ? 'btn btn__outline btn__active'
                : 'btn btn__outline'
            "
              style="font-size: 14px"
              (click)="changeResource(0)"
              >
              File
            </button>
            <button
              id="resourceVideoTypeButtonId"
              type="button"
            [class]="
              resourceData?.type == 2
                ? 'btn btn__outline btn__active'
                : 'btn btn__outline'
            "
              style="font-size: 14px"
              (click)="changeResource(2)"
              >
              Video
            </button>
            <button
              id="resourceUrlTypeButtonId"
              type="button"
            [class]="
              resourceData?.type == 1
                ? 'btn btn__outline btn__active'
                : 'btn btn__outline'
            "
              style="font-size: 14px"
              (click)="changeResource(1)"
              >
              URL
            </button>
          </div>
        </div>
        @if (resourceData?.type != 2 && resourceData?.type != 1) {
          <div
            class="form-group row align-items-center"
            >
            <label for="File" class="col-sm-3 control-label">
              <span ng-switch="resourceData?.type">File</span></label
              >
              <div class="col-sm-9">
                @if (
                  resourceData?.asset == null && progressbarDisplay.image == true
                  ) {
                  <div
                    class="progress progress-style"
                    style="margin-bottom: -7px"
                    >
                    <div
                      class="progress-bar progress-bar-striped progress-bar-animated"
                      role="progressbar"
                      [attr.aria-valuenow]="dynamicProgressbar.image"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      [style.width]="dynamicProgressbar.image + '%'"
                      >
                      {{ dynamicProgressbar.image }}%
                    </div>
                  </div>
                }
                @if (resourceData?.assetId) {
                  <span
                    class="resource-title file-title"
                    style="margin-bottom: -7px"
                    >
                    <a
                      id="resourceUploadedFileNameId"
                      target="_blank"
                      [href]="openResource(resourceData)"
                      >
                      {{ resourceData?.asset?.name || imageName }}</a
                      >
                    </span>
                  }
                  <div class="upload-btn-wrapper">
                    <button
                      class="btn btn__btn-default btn__orange"
                      style="padding: 6px !important"
                      >
                      Upload Resource
                    </button>
                    <input
                      class="uploadResource btn btn-primary"
                      id="file-in allbutton-style"
                      type="file"
                      #fileInputResource
                      (click)="clearResource()"
                      value=""
                      (change)="fileChangeEvent($event, resourceAllowedExtensions)"
                      />
                  </div>
                </div>
              </div>
            }
            @if (resourceData?.type == 1) {
              <div
                class="form-group row align-items-center"
                >
                <label for="linkUrl" class="col-sm-3 control-label">
                  <span ng-switch="resourceData.type">URL</span></label
                  >
                  <div
                    class="col-sm-9 error-container"
                    [ngClass]="{ error: dataSubmitted && form.linkUrl.errors }"
                    >
                    <input
                      type="url"
                      id="linkUrl "
                      formControlName="linkUrl"
                      name="linkUrl"
                      value="linkUrl"
                      style="text-transform: none"
                      class="form-control vplaybook__form__inputs"
                      placeholder="https://google.com"
                      />
                    @if (
                      form.linkUrl.errors &&
                      (form.linkUrl.dirty || form.linkUrl.touched || dataSubmitted)
                      ) {
                      <div
                        class="text-danger"
                        >
                        @if (
                          form.linkUrl.errors.pattern || form.linkUrl.errors.required
                          ) {
                          <div
                            >
                            Please enter valid URL (i.e. https://google.com)
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
              @if (resourceData?.type == 2) {
                <div>
                  <div class="form-group align-items-center">
                    <div class="row">
                      <label for="File" class="col-sm-3 control-label">Video</label>
                      <div class="col-sm-9">
                        @if (
                          resourceData?.asset == null &&
                          progressbarDisplay.asset == true
                          ) {
                          <div
                            class="progress progress-style"
                            style="margin-bottom: -7px"
                            >
                            <div
                              class="progress-bar progress-bar-striped progress-bar-animated"
                              role="progressbar"
                              aria-valuenow="0"
                              aria-valuemin="0"
                              aria-valuemax="100"
                  [ngStyle]="
                    (!videoProcessing && {
                      width: dynamicProgressbar.asset + '%'
                    }) || { width: '100%' }
                  "
                  [ngClass]="
                    dynamicProgressbar.asset
                      ? 'white-font'
                      : 'show-initial-status'
                  "
                              >
                              {{ !videoProcessing ? dynamicProgressbar.asset + "%" : "" }}
                              {{ videoProcessing }}
                            </div>
                          </div>
                        }
                        @if (resourceData?.assetId != null) {
                          <span
                            class="resource-title file-title file-resource-video-title"
                            style="margin-bottom: -7px"
                            >
                            <a
                              [href]="openResource(resourceData)"
                              target="_blank"
                              title="{{ resourceData?.asset.name }}"
                              >{{ resourceData?.asset.name }}</a
                              >
                            </span>
                          }
                          <div class="upload-btn-wrapper">
                            <button
                              class="btn btn__btn-default btn__orange"
                              style="padding: 6px !important"
                              >
                              Upload MP4
                            </button>
                            <app-video-chunks-upload
                              (progressPercentage)="progressPercentage($event)"
                              [chunksClass]="'uploadResource'"
                              (fileStatusUpdate)="fileStatusUpdate($event)"
                              [apiUrl]="apiUrl"
                              >
                            </app-video-chunks-upload>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="clear"></div>
                  </div>
                }
                <div class="form-group">
                  <div class="row align-items-center">
                    <label class="col-sm-3 control-label">Folder</label>
                    <div class="col-sm-9">
                      <div class="modal-drop custom-drop-btn-profile-groups col p-0">
                        <app-filter-dropdown
                          [isMultiSelect]="false"
                          [customTypeModal]="customTypeFilter"
                          [addButtonPlaceholder]="'Add New Folder'"
                          (selectedOptionEmitter)="setSelectedCategory($event)"
                          [id]="'profile-group'"
                          (updateOptionEmitter)="updateFolderName($event)"
                          [editableDropdown]="true"
                          (AddOptionEmmiter)="addFolder($event)"
                          [dropDownExtraClass]="dropDownExtraClass"
                          [isDropDownDisabled]="isDropDownDisabled"
                          [placeholderText]="getSelectedCategory()"
                          [enableResize]="true"
                          [notificationPageDropdown]="true"
                          [showNoneForSingleSelect]="true"
                          >
                        </app-filter-dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              @if (!pageTemplateId && !isUpdate && isCopyExists) {
                <button
                  class="btn vPlaybookDefaultButton btn__btn-default"
                  (click)="pasteResource()"
                  >
                  Paste Resource
                </button>
              }
              @if (!pageTemplateId && isUpdate) {
                <button
                  class="btn vPlaybookDefaultButton btn__btn-default"
                  (click)="copyResource(resourceData?.id)"
                  >
                  Copy Resource
                </button>
              }
              <button
                class="btn vPlaybookDefaultButton btn__btn-default"
                (click)="closeModal()"
                >
                Cancel
              </button>
              <button
                class="btn btn__btn-default btn__orange"
                [disabled]="disableSaveBtn"
                (click)="validateData()"
                >
                Save
              </button>
            </div>
          </div>
